import { createApp } from 'vue'
import GroupWork from './GroupWork.vue'
import './assets/global.css'

createApp(GroupWork).mount('#groupWork')
